import React from "react"
import ReactDOM from "react-dom"
import BusinessContact from "./business-contact-component"

export default class BusinessContactModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<BusinessContact {...this.modelJson} />, self.elem)
  }
}
